import React from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import compose from 'recompose/compose'
import findIndex from 'lodash/findIndex'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import moment from 'moment-timezone'

import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import SearchIcon from '@material-ui/icons/Search'
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd'

import SearchField from 'components/molecules/SearchField'
import SearchSimpleForm from 'components/molecules/SearchSimpleForm'
import SearchSimpleFields from 'components/molecules/SearchSimpleFields'
import { isString } from 'lib/detectType'

const styles = theme => ({
  SearchForm: {},
  secondaryAction: {
    paddingRight: theme.spacing(6)
  },
  searchSubmitBtn: {
    [theme.breakpoints.up('md')]: {
      minWidth: 120
    }
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  }
})

const getMinMaxDate = (items, range) => {
  const minDate =
    isString(range.minDate) && items.find(d => d.criteria === range.minDate)
      ? moment(items.find(d => d.criteria === range.minDate).value)
      : range.minDate || null
  const maxDate =
    isString(range.maxDate) && items.find(d => d.criteria === range.maxDate)
      ? moment(items.find(d => d.criteria === range.maxDate).value)
      : range.maxDate || null
  return { minDate, maxDate }
}

export const useProps = {
  options: { default: {}, types: 'object' },
  data: { default: {}, types: 'object' },
  items: { default: [], types: 'array' },
  condInfo: { default: {}, types: 'object' }
}
const SearchForm = props => {
  const { classes, proxy, ...others } = props
  const { options, data, items: totalItems, condInfo } = others
  const { simpleForm = false, disableEnter = false } = options
  const {
    onChangeSearchCriteria,
    onChangeSearchValue,
    onChangeSearchCondition,
    onClickAddSearchItem,
    onClickDeleteSearchItem,
    onSubmitSearch,
    onCancelSearch,
    onChangeDateRange,
    onChangeDatePicker
  } = proxy
  const simpleFieldSearchData = Object.keys(data).filter(criteria => {
    return data[criteria].simpleField
  })
  const items = totalItems.filter(item => {
    return simpleFieldSearchData.indexOf(item.criteria) === -1
  })
  const simpleFieldItems = totalItems.filter(item => {
    return simpleFieldSearchData.indexOf(item.criteria) !== -1
  })
  return (
    <div className={classes.SearchForm}>
      {simpleForm ? (
        <SearchSimpleForm
          data={data}
          items={items}
          totalItems={totalItems}
          disableEnter={disableEnter}
          onSubmitSearch={onSubmitSearch}
          onCancelSearch={onCancelSearch}
          onChangeDateRange={onChangeDateRange}
          onChangeDatePicker={onChangeDatePicker}
          onChangeSearchValue={onChangeSearchValue}
        />
      ) : (
        <Grid container spacing={1}>
          {simpleFieldSearchData.length > 0 &&
            simpleFieldItems.map((item, index) => {
              const { hash, criteria, value, condition } = item
              const itemIndex = findIndex(totalItems, o => o.hash === hash)
              const {
                label,
                type = 'text',
                dateFormat,
                value: selectValue,
                simpleFormDateRange = true,
                color = 'primary',
                range = {},
                hide = false,
                gridItemProps = {},
                datePickerProps = {}
              } = data[criteria] || {}
              if (hide === true) return null
              const { minDate, maxDate } = getMinMaxDate(totalItems, range)
              return (
                <Grid item xs={12} sm="auto" {...gridItemProps}>
                  <SearchSimpleFields
                    {...{
                      type,
                      label,
                      value,
                      color,
                      datePickerProps,
                      minDate,
                      maxDate,
                      itemIndex,
                      selectValue,
                      simpleFormDateRange,
                      condition,
                      dateFormat,
                      disableEnter,
                      onSubmitSearch,
                      onChangeSearchValue,
                      onChangeDateRange,
                      onChangeDatePicker
                    }}
                  />
                </Grid>
              )
            })}
          {items.map((item, index) => {
            const { hash, criteria, value, condition } = item
            const itemIndex = findIndex(totalItems, o => o.hash === hash)
            const {
              type = 'text',
              allowedConditions,
              hide = false,
              range = {},
              gridItemProps = {}
            } = data[criteria]
            if (hide === true) return null
            const { minDate, maxDate } = getMinMaxDate(totalItems, range)
            return (
              <Grid item xs={12} {...gridItemProps}>
                <SearchField
                  {...{
                    type,
                    itemIndex,
                    data,
                    criteria,
                    minDate,
                    maxDate,
                    value,
                    condition,
                    condInfo,
                    allowedConditions,
                    onChangeSearchCriteria,
                    onChangeSearchValue,
                    onChangeSearchCondition,
                    onClickDeleteSearchItem
                  }}
                />
              </Grid>
            )
          })}
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1} justify="space-between">
              <Grid item xs={12} sm="auto">
                <Button
                  variant="outlined"
                  onClick={onClickAddSearchItem}
                  color="primary"
                  disableRipple={isWidthUp('sm', props.width)}
                  fullWidth
                >
                  <PlaylistAddIcon className={classes.leftIcon} />
                  검색 조건 추가
                </Button>
              </Grid>
              <Grid item xs={12} sm="auto">
                <Grid container spacing={1}>
                  <Grid item xs={6} sm="auto">
                    <Button
                      className={classes.searchSubmitBtn}
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={onSubmitSearch}
                    >
                      <SearchIcon className={classes.leftIcon} />
                      검색
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm="auto">
                    <Button
                      className={classes.searchSubmitBtn}
                      variant="contained"
                      color="default"
                      fullWidth
                      onClick={onCancelSearch}
                    >
                      검색 취소
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </div>
  )
}
SearchForm.defaultProps = setDefaultProps(useProps)
SearchForm.propTypes = setPropTypes(useProps)
export default compose(withStyles(styles), withWidth())(SearchForm)
